import { EventTimeContext, getEventDateTimeDisplay } from '@libs/EventTime'

type EventDateTimeProps = {
  value?: string | null
  format: string
  event?: EventTimeContext | null
  className?: string
  secondaryClassName?: string
  showViewerLocal?: boolean
  viewerTimeZoneId?: string
}

export const EventDateTime = ({
  value,
  format,
  event,
  className,
  secondaryClassName = 'ml-1 text-xs opacity-75',
  showViewerLocal = true,
  viewerTimeZoneId,
}: EventDateTimeProps) => {
  if (!value) return null

  const display = getEventDateTimeDisplay(
    value,
    format,
    event,
    viewerTimeZoneId
  )

  return (
    <span className={className}>
      <time dateTime={display.dateTime}>
        {/* {showViewerLocal ? display.viewerLocal : display.eventLocal} */}
        {display.eventLocal}
      </time>
      {/* {showViewerLocal && display.showEventTime && ( */}
      {/*   <span className={secondaryClassName}> */}
      {/*     ( */}
      {/*     <time dateTime={display.dateTime}> */}
      {/*       {display.eventLocal} */}
      {/*     </time> */}
      {/*     ) */}
      {/*   </span> */}
      {/* )} */}
    </span>
  )
}

export default EventDateTime
